// Carrier mark style selection (pure). The user picks a *preferred* style; the
// *active* style is resolved against how many diseases are currently visible on
// the pedigree, because the Vertical line convention (Bennett 2022) is only
// unambiguous when a single disease is filtered.
//
// NOTE: this governs ONLY the gene→disease carrier marks (border / vertical line).
// The legacy +/- genotype Carrier-Status annotation is a separate, intentionally
// untouched pipeline and must not be merged into this one.

export const CARRIER_MARK_STYLE = Object.freeze({
  border: 'border',
  verticalLine: 'verticalLine'
});

export const DEFAULT_CARRIER_MARK_STYLE = CARRIER_MARK_STYLE.border;

// Given the user's preferred style and the number of diseases visible on the
// pedigree, return the style actually rendered plus whether an auto-fallback is
// in effect (preferred vertical line but >1 or 0 disease visible).
export function resolveCarrierStyle(preferredStyle, visibleDiseaseCount) {
  const preferred =
    preferredStyle === CARRIER_MARK_STYLE.verticalLine
      ? CARRIER_MARK_STYLE.verticalLine
      : CARRIER_MARK_STYLE.border;

  if (preferred === CARRIER_MARK_STYLE.verticalLine) {
    if (visibleDiseaseCount === 1) {
      return {
        activeStyle: CARRIER_MARK_STYLE.verticalLine,
        fallbackActive: false
      };
    }
    return { activeStyle: CARRIER_MARK_STYLE.border, fallbackActive: true };
  }
  return { activeStyle: CARRIER_MARK_STYLE.border, fallbackActive: false };
}
